/**
 * Filtering across all columns with AND logic. Normal behavior.
 */
export function useAndFiltering(row, id, filterValue) {
  if (!filterValue || filterValue.length === 0) return true;
  return filterValue.includes(row.getValue(id));
};

/**
 * Filtering across all columns with OR logic.
 */
let searchTerms = {};
export function useOrFiltering(row, id, filterValue) {
  // add or remove the filter value from the searchTerms object
  if (filterValue.length > 0) {
    searchTerms[id] = filterValue;
  } else {
    delete searchTerms[id];
  }

  // Get all filter values from all filters
  let allFilterValues = Object.values(searchTerms).flat();
  const valuesInRow = Object.values(row.original);

  // If there are no filter values, return true (no filtering)
  if (allFilterValues.length === 0) return true;

  return allFilterValues.some((term) => valuesInRow.includes(term));
};
